// extracted by mini-css-extract-plugin
module.exports = {"hero":"InsightsInsightLandingHeader_hero__904vW","search-fade-in":"InsightsInsightLandingHeader_search-fade-in__uwU5R"};